var map = {
	"./da.svg": "73cb",
	"./de.svg": "b7a7",
	"./denmark.svg": "3f6c",
	"./en.svg": "4a63",
	"./id.svg": "b6d1",
	"./no.svg": "cd68",
	"./norway.svg": "a03f",
	"./se.svg": "87f8",
	"./uk.svg": "cece"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "c8cf";